var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevertGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39275 13.6867C9.70853 13.8163 11.0285 13.4855 12.1278 12.7509C13.227 12.0162 14.0375 10.9231 14.4211 9.65784C14.8047 8.39257 14.7376 7.03343 14.2314 5.81204C13.7252 4.59065 12.8111 3.5826 11.6449 2.95966C10.4787 2.33672 9.13259 2.13746 7.83594 2.39582C6.53929 2.65417 5.37235 3.35417 4.53399 4.37652C3.69562 5.39886 3.23771 6.68029 3.23828 8.00243V9.26973",
    stroke: "#6B7280",
    strokeWidth: 1.90476,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.9 2.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8L3.23826 9.90476L5.14302 8",
    stroke: "#6B7280",
    strokeWidth: 1.90476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertGray);
export default __webpack_public_path__ + "static/media/RevertGray.e703592992db2156b4a5771a3b4a3eab.svg";
export { ForwardRef as ReactComponent };